import { MONEY_SCALE, QUANTITY_SCALE, UNIT_PRICE_SCALE, fromString, round, toString, zero, } from '@aeris/money';
// ---------------------------------------------------------------------------
// Amounts
// ---------------------------------------------------------------------------
export const ZERO_AMOUNT = zero(MONEY_SCALE);
export const ZERO_COST = zero(UNIT_PRICE_SCALE);
export const ZERO_QUANTITY = zero(QUANTITY_SCALE);
/**
 * Reads an amount from a string, at a given scale.
 *
 * A string, always — NUMERIC arrives from the driver as text and travels the
 * wire as text precisely so that no boundary can round it (ADR-0016). Null
 * rather than a throw, because unparseable input is ordinary, not a bug.
 */
const parseAt = (value, scale) => {
    try {
        return round(fromString(value.trim()), scale, 'half-up');
    }
    catch {
        return null;
    }
};
export const parseAmount = (value) => parseAt(value, MONEY_SCALE);
export const parseUnitCost = (value) => parseAt(value, UNIT_PRICE_SCALE);
export const parseQuantity = (value) => parseAt(value, QUANTITY_SCALE);
/** The wire and database format. Never a JSON number. */
export const amountToString = (value) => toString(value);
//# sourceMappingURL=entities.js.map